import React from 'react';
import Box from '@components/Atoms/Box';
import { useHasAction } from './ActionRequiredContext';
import { ActionPath } from './services/actionRequiredService';

type Props = {
  children: React.ReactNode;
  checkPath: ActionPath;
  showBadge?: boolean;
};

const ActionRequiredWrapper = ({ children, checkPath, showBadge = true }: Props) => {
  const hasAction = useHasAction(checkPath);

  return (
    <Box
      className={`action-required-wrapper ${hasAction ? 'has-action' : ''}`}
      sx={{
        '@keyframes pulse': {
          '0%': { opacity: 1 },
          '50%': { opacity: 0.7 },
          '100%': { opacity: 1 },
        },
        display: 'contents',
        // Target direct .actionable children only (prevent multi-level)
        '&.action-required-wrapper.has-action .actionable': {
          position: 'relative',
          '&:after': {
            content: '""',
            position: 'absolute',
            top: '-1px',
            right: '-1px',
            width: '6px',
            height: '6px',
            backgroundColor: '#ff3b30',
            borderRadius: '50%',
            border: '1px solid #ff3b30',
            zIndex: 1,
            animation: 'pulse 2s infinite',
            // display: showBadge && hasAction ? 'block' : 'none',
            opacity: showBadge && hasAction ? 1 : 0,
          },
        },
        // Ensure no action indicator when no action is required
        '&.action-required-wrapper:not(.has-action)  .actionable': {
          position: 'relative',
          '&:after': {
            // display: 'none',
            opacity: 0,
          },
        },
        // Prevent nested action-required-wrapper from affecting parent's .actionable
        '&.action-required-wrapper .action-required-wrapper .actionable': {
          '&:after': {
            // display: 'none',
            opacity: 0,
          },
        },
      }}
    >
      {children}
    </Box>
  );
};

export default ActionRequiredWrapper;
